export enum SettingsStages {
	MAIN = 'main',
	GLOBAL = 'global',
	SCREEN = 'screen',
}
